<template>
  <div/>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { watch } from 'vue';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataExchangePairs',
});

// Базовый тип для сообщений с ID пары биржи
type ExchangePairWithId = {
  idExchangePair: number;
};

// Типы для WebSocket сообщений компонента exchangePairs
type ExchangePairsListMessage = WebSocketMessageWithFields<'exchange-pair' | 'global-pair-exchange' | 'pair' | 'helper-agents', {
  exchangePairs: unknown[];
}>;
type ExchangePairNotFoundMessage = WebSocketMessageEmpty<'exchange-pair-not-found'>;
type ExchangePairAddMessage = WebSocketMessageWithFields<'exchange-pair-add' | 'exchange-pair-add-success', ExchangePairWithId & {
  idExchange: number;
  idCurrencyPrimary: number;
  idCurrencySecondary: number;
  offset: number;
  locked?: boolean;
}>;
type ExchangePairDeleteMessage = WebSocketMessageWithFields<'exchange-pair-delete' | 'exchange-pair-delete-success', ExchangePairWithId>;
type ExchangePairLockMessage = WebSocketMessageWithFields<'exchange-pair-lock' | 'exchange-pair-lock-success', ExchangePairWithId>;
type ExchangePairUnlockMessage = WebSocketMessageWithFields<'exchange-pair-unlock' | 'exchange-pair-unlock-success', ExchangePairWithId>;

// Объединенный тип для всех сообщений
type ExchangePairsWebSocketMessage = 
  | ExchangePairsListMessage 
  | ExchangePairNotFoundMessage 
  | ExchangePairAddMessage 
  | ExchangePairDeleteMessage 
  | ExchangePairLockMessage 
  | ExchangePairUnlockMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: ExchangePairsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'exchange-pair':
    case 'global-pair-exchange':
    case 'pair':
    case 'helper-agents':
      store.dispatch('exchangePairs/wsExchangePairs', { exchangePairs: data.exchangePairs });
      break;
    case 'exchange-pair-not-found':
      store.dispatch('exchange/wsSetEmptyExchange');
      break;
    case 'exchange-pair-add': // TODO: rename to 'create'
    case 'exchange-pair-add-success':
      store.dispatch('exchangePairs/wsExchangePairsCreate', {
        idExchangePair: data.idExchangePair,
        idExchange: data.idExchange,
        idCurrencyPrimary: data.idCurrencyPrimary,
        idCurrencySecondary: data.idCurrencySecondary,
        offset: data.offset,
        locked: data.locked ?? false,
      });
      break;
    case 'exchange-pair-delete':
    case 'exchange-pair-delete-success':
      store.dispatch('exchangePairs/wsExchangePairsDelete', {
        idExchangePair: data.idExchangePair,
      });
      break;
    case 'exchange-pair-lock':
    case 'exchange-pair-lock-success':
      store.dispatch('exchangePairs/wsExchangePairsLock', {
        idExchangePair: data.idExchangePair,
      });
      break;
    case 'exchange-pair-unlock':
    case 'exchange-pair-unlock-success':
      store.dispatch('exchangePairs/wsExchangePairsUnlock', {
        idExchangePair: data.idExchangePair,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
